import { Tower } from "../entities";
import type { LevelSim } from "../levelSim";
import { BASE_TIERS, canRaise } from "./ascension";

/**
 * Why an Upgrade card cannot raise a tower (docs/TOWERS_V2.md "Tier 4"): it is at its top tier, or it is a tier-3
 * tower whose type has two branches but no Ascend card taken yet (tier 4 comes only from an Ascend card, dealt from
 * `pacing.minLevel`). `None` when it can be raised. Read by the Upgrade card's tap and the tower sheet.
 */
export enum RaiseBlock { None = 0, MaxTier = 1, NeedsAscend = 2 }

export function raiseBlock(sim: LevelSim, t: Tower): RaiseBlock {
  if (canRaise(sim, t)) return RaiseBlock.None;
  const branches = sim.balance.branches.byTower[t.archetype] ?? [];
  const tiers = sim.balance.towers[t.archetype]?.tiers.length ?? 0;
  return t.alive && t.tier === BASE_TIERS && tiers === BASE_TIERS && branches.length === 2 && (sim.ascension.branchOf[t.archetype] ?? -1) < 0
    ? RaiseBlock.NeedsAscend : RaiseBlock.MaxTier;
}

/** Whether this level deals Ascend cards at all (the campaign from `pacing.minLevel`). */
export const dealsAscend = (sim: LevelSim): boolean => sim.levelNumber >= sim.balance.branches.pacing.minLevel;
